import { useCallback } from 'react';
import { useAtom } from 'jotai';
import {
    acceptQuotePopupOpenAtom,
    acceptQuotePopupUuidAtom,
    acceptQuotePopupCustomerNameAtom,
    acceptQuotePopupCustomerEmailAtom,
} from '../states/accept-quote-popup-atoms';

/**
 * Custom hook for managing accept quote popup state and logic
 * @returns Object containing popup state and control functions
 */
export const useAcceptQuote = () => {
    const [isAcceptQuotePopupOpen, setIsAcceptQuotePopupOpen] = useAtom(
        acceptQuotePopupOpenAtom
    );
    const [currentUuid, setCurrentUuid] = useAtom(acceptQuotePopupUuidAtom);
    const [customerName, setCustomerName] = useAtom(
        acceptQuotePopupCustomerNameAtom
    );
    const [customerEmail, setCustomerEmail] = useAtom(
        acceptQuotePopupCustomerEmailAtom
    );

    const openPopup = useCallback(
        (uuid: string, name?: string, email?: string) => {
            setCurrentUuid(uuid);
            setCustomerName(name || '');
            setCustomerEmail(email || '');
            setIsAcceptQuotePopupOpen(true);
        },
        [
            setCurrentUuid,
            setCustomerName,
            setCustomerEmail,
            setIsAcceptQuotePopupOpen,
        ]
    );

    const closePopup = useCallback(() => {
        setIsAcceptQuotePopupOpen(false);
        setCurrentUuid('');
        setCustomerName('');
        setCustomerEmail('');
    }, [
        setIsAcceptQuotePopupOpen,
        setCurrentUuid,
        setCustomerName,
        setCustomerEmail,
    ]);

    return {
        isAcceptQuotePopupOpen,
        openPopup,
        closePopup,
        currentUuid,
        customerName,
        customerEmail,
    };
};
